import { useMemo } from 'react';
import { getSortedList } from '@/hooks/list-order';
import { TVehiculeCheckResultSchema } from '@/schemas/vehicule-check-result/vehicule-check-result.schema';
import { TFunction } from 'i18next';
import { TTranslatedCheckPointSchema } from '@/schemas/translated-check-point/translated-check-point.schema';

interface UseGetResultVideoChapterProps {
  t: TFunction<undefined>;
  isLoading: boolean;
  vehiculeCheckResult: TVehiculeCheckResultSchema;
  getTranslatedCheckPoint: (
    checkPointId: string,
  ) => TTranslatedCheckPointSchema;
}

export const useGetResultVideoChapters = ({
  t,
  isLoading,
  vehiculeCheckResult,
  getTranslatedCheckPoint,
}: UseGetResultVideoChapterProps) => {
  const videoChapterData = useMemo(() => {
    if (isLoading || !vehiculeCheckResult?.results?.length) {
      return [];
    }

    const checkpoints = getSortedList(
      // vehiculeCheckResult?.results?.filter(
      //   (item) => item?.checkPoint?.isVideo,
      // ) || [],
      vehiculeCheckResult?.results || [],
      'checkPoint.startTimeInVideo',
      'asc',
    );

    return checkpoints?.map((item, index) => {
      const translatedCheckPoint = getTranslatedCheckPoint(
        item?.checkPoint?.id,
      );
      const startTime = item?.checkPoint?.startTimeInVideo || 0;
      const nextItem = checkpoints[index + 1];
      const endTime = nextItem?.checkPoint?.startTimeInVideo ?? Infinity;

      return {
        startTime,
        endTime,
        title: `${translatedCheckPoint?.name || item?.checkPoint?.name} ${item?.checkPoint?.isVideo ? '' : `(${t('common:photo')})`}`,
      };
    });
  }, [t, isLoading, vehiculeCheckResult, getTranslatedCheckPoint]);

  return {
    videoChapterData,
  };
};
